import BaseMultilingual from '~~utils/Multilingual';

const localMapping = {
  USER_PROFILE: {
    LANG_PREFERENCE: {
      'zh-TW': '語言偏好',
      en: 'Language Preference',
    },
    LANG_PREFERENCE_HINT: {
      'zh-TW': '繁中以外僅部分支援',
      en: 'Partial support for EN',
    },
    LANG_PREFERENCE_RESULT: {
      'zh-TW': '依照瀏覽器預設語言顯示',
      en: 'Base on Browser Default Language',
    },
  },
};

const Multilingual = (textCode, lang = '') => {
  return BaseMultilingual(textCode, localMapping, lang);
};
export default Multilingual;
